import React from 'react';
import autobind from 'autobind-decorator';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

const getItemStyle = (isDragging, draggableStyle) => (
	{
		borderStyle: isDragging ? 'dashed' : 'solid',
		borderColor: isDragging ? '#cecece' : 'transparent',

		// styles we need to apply on draggables
		...draggableStyle
	}
);

class HFMDragDropContext extends React.Component {
	render () {
		const {
			dragDropList,
			ItemButton,
			ItemLabel,
			className = 'dnd-item-list'
		} = this.props;

		return (
			<DragDropContext onDragEnd={ this.onDragEnd }>
				<Droppable droppableId="droppable">
					{
						({ innerRef }, { isDraggingOver }) => (
							<div ref={ innerRef } className={ className }>
								{
									dragDropList.map((item, index) => {
										const { id } = item;

										return (
											<Draggable key={ id } draggableId={ id } index={ index }>
												{
													(provided, snapshot) => (
														<div data-ta="dragDropItem">
															<div
																{ ...provided.draggableProps }
																{ ...provided.dragHandleProps }
																ref={ provided.innerRef }
																className="dnd-item-list-item"
																style={getItemStyle(
																	snapshot.isDragging,
																	provided.draggableProps.style
																)}
															>
																<div className="grid-x align-middle">
																	<div className="cell shrink">
																		<ItemButton { ...item.serialized } />
																	</div>
																	<div className="cell auto">
																		<ItemLabel { ...item.serialized } />
																	</div>
																	<div className="cell shrink text-center">
																		<span className="icon fi-braille" style={{
																			color: '#999'
																		}}></span>
																	</div>
																</div>
															</div>
															{ provided.placeholder }
														</div>
													)
												}
											</Draggable>
										);
									})
								}
							</div>
						)
					}
				</Droppable>
			</DragDropContext>
		);
	}

	@autobind
	onDragEnd (result) {
		// dropped outside the list
	    if (!result.destination) {

			return;
	    }

		const { onDragEnd } = this.props;
		onDragEnd(result);
	}
}

export default HFMDragDropContext;
